import React, { Component } from "react";

class LiverBiopsy extends Component {
    render() {
      return (
        <>
            <h4>Liver Biopsy</h4>

            <div className="video-container">
            <iframe width="853" title="liver biopsy video" height="480" src="https://www.youtube.com/embed/uMfwNL0Kfmw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <p>
            With a liver biopsy (BYE-op-see), the
            physician is able to examine a small piece
            of tissue from your liver for signs of
            damage or disease. This procedure
            involves using a special needle to remove
            tissue from the liver. The physician
            decides to do a liver biopsy after tests
            suggest that the liver does not work
            properly. For example, a blood test
            might show that your blood contains
            higher than normal levels of liver
            enzymes or too much iron or copper. An
            x-ray could suggest that the liver is
            swollen. Looking at liver tissue itself is
            the best way to determine whether the
            liver is healthy.</p>

            <h5>Preparation</h5>

            <p>Before scheduling your biopsy, the
            physician will take blood samples to
            make sure your blood clots properly. Be
            sure to mention any medications you
            take, especially those, like blood
            thinners, that affect blood clotting. One
            week before the surgery, you will have
            to stop taking aspirin, ibuprofen, and
            anticoagulants. You will also have a
            chest x-ray.</p>

            <p>You must not eat or drink anything for 8
            hours before the biopsy, and you should
            plan to arrive at the hospital about an
            hour before the scheduled time of the
            surgery. Your physician will tell you
            whether to take your normal medications	during the fasting period and may give you other special instructions.</p>

            <h5>Procedure</h5>

            <p>Liver biopsy is considered minor surgery and is done at the hospital. The nurse will start
            an intravenous line to give you medication for the procedure. For the biopsy, you will lie
            on a hospital bed on your back or turned slightly to the left side, with your right hand
            above your head. After marking the outline of your liver and injecting a local anesthetic to
            numb the area, the physician will make a small incision in your right side near your rib
            cage, then insert the biopsy needle and retrieve a sample of liver tissue. In some cases, the
            physician may use an ultrasound image of the liver to help guide the needle to a specific
            spot.</p>

            <p>You will need to hold very still so that the physician does not nick the lung or gallbladder,
            which are close to the liver. The physician will ask you to hold your breath for 5 to 10
            seconds while he or she puts the needle in your liver. You may feel a dull pain. The entire
            procedure takes about 20 minutes.</p>

            <p>Two other methods of liver biopsy are also available. For a laparoscopic biopsy, the
            physician inserts a special tube called a laparoscope through an incision in the abdomen.
            The laparoscope sends images of the liver to a monitor. The physician watches the monitor
            and uses instruments in the laparoscope to remove tissue samples from one or more parts
            of the liver. Physicians use this type of biopsy when they need tissue samples from
            specific parts of the liver.</p>

            <p>Transvenous biopsy involves inserting a tube called a catheter into a vein in the neck and
            guiding it to the liver. The physician puts a biopsy needle into the catheter and then into the
            liver. Physicians use this procedure when patients have blood-clotting problems or fluid in
            the abdomen.</p>

            <h5>Recovery</h5>

            <p>After the biopsy, the physician will put a bandage over the incision and have you lie on
            your right side, pressed against a towel, for at least 2 hours. The nurse will monitor your
            vital signs and level of pain. You may remain in the hospital for up to 24 hours after the
            surgery to recover from the sedative and to allow the medical staff to check you for
            complications before sending you home.</p>

            <p>
                You will need to arrange to have someone take you home from the hospital since you will
            not be allowed to drive after having the sedative. You must go directly home and remain in
            bed (except to use the bathroom) for 8 to 12 hours, depending on your physician's
            instructions. Also, be sure not to exert yourself too much for the next week so that the
            incision and liver can heal. You can expect a little soreness at the incision site, and you
            might have some pain in your right shoulder. This pain is caused by irritation of the
            diaphragm muscle (the pain usually radiates to the shoulder) and should disappear within a
            few hours or days. Your physician may recommend that you take Tylenol for pain, but
            you must not take aspirin or ibuprofen for the first week after surgery. These medicines
            decrease blood clotting, which is crucial for healing.
            </p>

            <p>Like any surgery, liver biopsy does have some risks, such as puncture of the lung or
            gallbladder, infection, bleeding, and pain, but these complications are rare.</p>
        </>
      );
    }
  }
   
  export default LiverBiopsy;